import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home.vue'
import Login from '@/components/Login'
import Forbidden from '@/components/Forbidden'

import Articles from '../components/Articles/ArticlesOverview'
import ArticleDetails from '../components/Articles/ArticleDetail'
import Logging from '../components/Logging/LoggingOverview'
import LoggingDetails from '../components/Logging/LoggingDetail'
import DownloadUpload from '../components/Articles/DownloadUpload'
/*import Jobs from '../components/Jobs/JobsOverview'*/

import { getInstance } from '../services/AuthenticationService'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: (to, from, next) => {
      const authService = getInstance()

      if (authService.isAuthenticated) {
        next({ name: 'home' })
      } else {
        next()
      }
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: Forbidden,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/articles',
    name: 'articles',
    component: Articles,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/articles/:id',
    name: 'articledetails',
    props: route => ({ articleId: Number(route.params.id) }),
    component: ArticleDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/logging',
    name: 'logging',
    component: Logging,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/logging/:id',
    name: 'loggingdetails',
    props: route => ({ loggingId: Number(route.params.id) }),
    component: LoggingDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/downloadupload',
    name: 'downloadupload',
    component: DownloadUpload,
    meta: {
      requiresAuth: true
    }
  }
  //{
  //  path: '/jobs',
  //  name: 'jobs',
  //  component: Jobs,
  //  meta: {
  //    requiresAuth: true
  //  }
  //}
]

const router = new VueRouter({
  routes
})

export default router
